import React from "react";
// import { Link as SmartLink } from "react-router-dom";

const Link = ({ to, href, children, ...props }) => (
  <a href={to || href} color="inherit" {...props}>
    {children}
  </a>
);
export default Link;
